<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600" @click:outside="$emit('onClose')">
      <v-card class="not-margin d-flex flex-column" style="max-height: 90vh;">
        <!-- <v-toolbar dark color="error">
          <v-toolbar-title>
            <v-icon left>mdi-alert</v-icon>
            Alerta - Perfil em uso
          </v-toolbar-title>
        </v-toolbar> -->
        
        <v-card-text class="pa-4 flex-grow-1" style="overflow-y: hidden;">
          <v-row class="d-flex justify-center">
            <v-col cols="12" class="text-center">
              <v-icon color="error" size="64">mdi-alert-circle</v-icon>
              <div class="text-subtitle-1 font-weight-bold mt-2">
                O registro selecionado está em uso nos seguintes lugares:
              </div>
            </v-col>
          </v-row>

          <v-row class="flex-grow-1" style="min-height: 0;">
            <v-col cols="12" class="d-flex flex-column" style="height: 100%;">
              <v-list class="flex-grow-1" style="overflow-y: auto;">
                <v-list-item v-for="(item, index) in paginatedItems" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <div v-if="paginatedItems.length === 0" class="text-center py-4">
                  Nenhum registro encontrado
                </div>
              </v-list>
              
              <div class="text-center pt-2">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                  circle
                  :total-visible="7"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Área inferior fixa com organização vertical -->
        <div class="footer-area pt-2">
          <v-divider></v-divider>
          
          <v-row class="ma-0">
            <v-col cols="12" class="text-center py-2">
              <div class="text-subtitle-1">
                Total de ocorrências: {{ locaisDeUso.length }}
              </div>
            </v-col>
          </v-row>
          
          <v-row class="ma-0">
            <v-col cols="12" class="text-center pb-4">
              <v-btn color="primary" @click="$emit('onClose')">
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      page: 1,  // Inicia sempre na página 1
      itemsPerPage: 5,
      windowHeight: 0
    }
  },
  computed: {
    locaisDeUso() {
      return Array.isArray(this.content) ? this.content : 
             (this.content.locaisDeUso || []);
    },
    pageCount() {
      return Math.ceil(this.locaisDeUso.length / this.itemsPerPage);
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.locaisDeUso.slice(start, end);
    }
  },
  watch: {
    // Observa mudanças no content e reseta para a página 1
    content: {
      handler() {
        this.page = 1;
      },
      deep: true
    }
  },
  mounted() {
    this.calculateItemsPerPage();
    window.addEventListener('resize', this.calculateItemsPerPage);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateItemsPerPage);
  },
  methods: {
    calculateItemsPerPage() {
      const itemHeight = 48;
      const fixedHeights = 450;
      const availableHeight = window.innerHeight * 0.9 - fixedHeights;
      this.itemsPerPage = Math.max(1, Math.floor(availableHeight / itemHeight));
      
      const newPageCount = this.pageCount;
      if (this.page > newPageCount && newPageCount > 0) {
        this.page = newPageCount;
      }
    }
  }
};
</script>


<style scoped>
.not-margin {
  margin: 0;
}

.v-list {
  scrollbar-width: thin;
}

.flex-grow-1 {
  flex-grow: 1;
}

.footer-area {
  flex-shrink: 0;
  background: white;
}

/* Espaçamento consistente entre os elementos */
.v-divider {
  margin-top: 0;
  margin-bottom: 8px;
}

.text-subtitle-1 {
  margin-bottom: 8px;
}
</style>